/**
 * @generated SignedSource<<031455028abba17733d29b575bb22339>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveAdminFromSystemInput = {
  email: string;
  systemId: string;
};
export type useAdminMutationsRemoveFromSystemMutation$variables = {
  input: RemoveAdminFromSystemInput;
};
export type useAdminMutationsRemoveFromSystemMutation$data = {
  readonly removeAdminFromSystem: {
    readonly email: string;
    readonly firstName: string;
    readonly id: string;
    readonly lastName: string;
  };
};
export type useAdminMutationsRemoveFromSystemMutation = {
  response: useAdminMutationsRemoveFromSystemMutation$data;
  variables: useAdminMutationsRemoveFromSystemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminUser",
    "kind": "LinkedField",
    "name": "removeAdminFromSystem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAdminMutationsRemoveFromSystemMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAdminMutationsRemoveFromSystemMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2969aeab5b66ebd61e4ff140aec8cfbd",
    "id": null,
    "metadata": {},
    "name": "useAdminMutationsRemoveFromSystemMutation",
    "operationKind": "mutation",
    "text": "mutation useAdminMutationsRemoveFromSystemMutation(\n  $input: RemoveAdminFromSystemInput!\n) {\n  removeAdminFromSystem(input: $input) {\n    id\n    email\n    firstName\n    lastName\n  }\n}\n"
  }
};
})();

(node as any).hash = "062adc73d3a8f417de33c5eff492b1e5";

export default node;
